import { Box, Typography } from "@mui/material";

const styles = {
  infoBox: {
    mx: { xs: 2.5, md: 4 },
    my: 3,
    p: 3,
    borderRadius: 2,
    background: "#eef6ff",
    display: "flex",
    gap: 1.5,
    alignItems: "flex-start",
    border: "1.5px solid #dbeafe",
  },
};

interface Props {
  title: string | JSX.Element;
  description: string | JSX.Element;
  icon: JSX.Element | string;
  bgColor?: string;
  iconColor?: string;
  titleColor?: string;
  descriptionColor?: string;
  borderColor?: string;
  error?: boolean;
  button?: JSX.Element;
}
const InfoBox = ({
  title,
  description,
  icon,
  bgColor = "#eef6ff",
  iconColor = "#2563eb",
  titleColor = "#1e40af",
  descriptionColor = "#1d4ed8",
  borderColor = "#dbeafe",
  button = undefined,
  error,
}: Props) => {
  const resolvedBgColor = error ? "#fff5f5" : bgColor;
  const resolvedIconColor = error ? "#c0392b" : iconColor;
  const resolvedTitleColor = error ? "#7f1d1d" : titleColor;
  const resolvedDescriptionColor = error ? "#7f1d1d" : descriptionColor;
  const resolvedBorderColor = error ? "#fca5a5" : borderColor;

  return (
    <Box
      sx={{
        ...styles.infoBox,
        background: resolvedBgColor,
        border: `1.5px solid ${resolvedBorderColor}`,
      }}
    >
      <Box
        component="i"
        className={`${icon}`}
        sx={{ fontSize: 18, color: resolvedIconColor, mt: 0.25, flexShrink: 0 }}
      />
      <Box>
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 600,
            color: resolvedTitleColor,
            mb: 0.5,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            color: resolvedDescriptionColor,
            lineHeight: 1.6,
          }}
        >
          {description}
        </Typography>
      </Box>

      {button && <Box sx={{ ml: "auto" }}>{button}</Box>}
    </Box>
  );
};

export default InfoBox;
